import { r } from "../utils/routing";

export function toggleModal(id, currentRoute, callback) {
  if (currentRoute === r("storyline") || currentRoute === r("database")) {
    callback(id);
  } else {
    console.error("cant open modal on this page");
  }
}
